import axios from "axios";
import axiosInterceptor from "./axiosInterceptor";

const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const httpClient = axios.create({
    baseURL: REACT_APP_API_BASE_URL,
});

axiosInterceptor(httpClient);
export default httpClient;